import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Box from 'ui-box';
import AntdAlertErrorBoundary from '../../components/common/AntdAlertErrorBoundary';
import MobileHeader from '../../components/mobile/Header';
import UserAccountScreen from '../../pages/mobile/user-account/UserAccountScreen';
import PersonalInformationScreen from '../../pages/mobile/user-account/PersonalInformationScreen';
import ContactPreferenceScreen from '../../pages/mobile/user-account/ContactPreferenceScreen';
import AccountCredentialScreen from '../../pages/mobile/user-account/AccountCredentialScreen';
import LoginWithEmailScreen from '../../pages/mobile/user-account/LoginWithEmailScreen';

function MobileUserAccountLayout() {

  return (
    < >
      <Box position="relative" height="100%">
        <AntdAlertErrorBoundary>
          <MobileHeader />
        </AntdAlertErrorBoundary>
        <AntdAlertErrorBoundary>
          <Box paddingTop={24} paddingBottom={12} paddingX={20} marginBottom={40}>
            <Switch>
              <Route path="/user-account/account-credential/login-with-email">
                <LoginWithEmailScreen />
              </Route>
              <Route path="/user-account/account-credential">
                <AccountCredentialScreen />
              </Route>
              <Route path="/user-account/contact-preference">
                <ContactPreferenceScreen />
              </Route>
              <Route path="/user-account/personal-information">
                <PersonalInformationScreen />
              </Route>
              <Route path="/user-account">
                <UserAccountScreen />
              </Route>
            </Switch>
          </Box>
        </AntdAlertErrorBoundary>
      </Box>
    </>
  );
}

export default MobileUserAccountLayout;
